export const numbersEqual = (a: number, b: number): boolean =>
  Math.abs(b - a) < 1e-14;

export const firstGreaterThanSecond = (a: number, b: number): boolean =>
  !numbersEqual(a, b) && a > b;

export const firstLessThanSecond = (a: number, b: number): boolean =>
  !numbersEqual(a, b) && a < b;
